<template>
  <div>
    <div class="mb-4">
      <inertia-link :href="route('admin.inventory.brands')" class="rounded p-2 mb-3 border">back</inertia-link>
    </div>

    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('admin.inventory.brands')">Inventory</inertia-link>
      <span>/ {{ brand.name }}</span>
    </h1>

    <div class="grid lg:grid-cols-3 gap-3">

      <div v-for="product in activeProducts" :key="product.id" class="border relative border-gray-100 shadow bg-white rounded-lg flex flex-row overflow-hidden">
        <div class="bg-contain bg-no-repeat bg-bottom min-w-12 w-32 h-24 bg-white block" :style="`background-image: url(${product.image}); background-position: 50% 50%;`"></div>
        <div class="p-3">
          <h1 class="text-lg mb-2">{{ product.description }}</h1>
          <div>
            <h3 class="text-sm text-gray-400">{{ product.item_code }}
              <span v-if="product.active" class="bg-green-200 text-green-700 rounded px-1 py-0 text-xs">Active</span>
              <span v-else class="bg-red-200 text-red-700 rounded px-1 py-0 text-xs">Inactive</span>
            </h3>
            <div v-if="product.prices.length">
              <div v-for="item in product.prices" class="w-full border-b pb-1">
                <div class="flex gap-2 justify-between">
                  <h3 class="text-sm font-medium mt-2">{{ item.uom }}
                    <Icon v-if="item.active" name="tick" class="inline-block text-gray-600 h-4 w-4 text-green-700" />
                  </h3>
                  <h3 class="text-sm font-medium mt-2">MVR {{ item.price }}</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-grow flex flex-col items-end p-3">
            <p class="text-xs text-gray-500 mb-1">IN STOCK</p>
            <div class="text-right flex items-end">
              <h1 class="text-lg text-xl font-light">{{ product.in_stock }}</h1>
              <h3 class="text-sm ml-1">{{ product.base_unit }}</h3>
            </div>
          <div class="my-2">
            <div class="px-2 py-1 bg-blue-500 text-white text-xs" v-if="product.tagLabel">{{product.tagLabel}}</div>
          </div>
        </div>
      </div>


      <div v-for="product in inactiveProducts" :key="product.id" class="border border-gray-100 shadow bg-white rounded-lg flex flex-row overflow-hidden">
        <div class="bg-contain bg-no-repeat bg-bottom min-w-12 w-32 h-24 bg-white block" :style="`background-image: url(${product.image}); background-position: 50% 50%;`"></div>
        <div class="p-3">
          <h1 class="text-lg mb-2">{{ product.description }}</h1>
          <div>
            <h3 class="text-sm text-gray-400">{{ product.item_code }}
              <span v-if="product.active" class="bg-green-200 text-green-700 rounded px-1 py-0 text-xs">Active</span>
              <span v-else class="bg-red-200 text-red-700 rounded px-1 py-0 text-xs">Inactive</span>
            </h3>
          </div>
        </div>
        <div class="flex-grow flex flex-col items-end p-3">
          <p class="text-xs text-gray-500 mb-1">IN STOCK</p>
          <div class="text-right flex items-end">
            <h1 class="text-lg text-xl font-light">{{ product.in_stock }}</h1>
            <h3 class="text-sm ml-1">{{ product.base_unit }}</h3>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import Layout from '@/Shared/Admin/Layout'

  export default {
    name: 'Details',
    layout: Layout,
    components: {

    },

    props: {
      brand: Object,
      products: Array
    },

    computed: {
      activeProducts: function() {
        return this.products.filter((item) => {
          return item.active
        })
      },

      inactiveProducts: function() {
        return this.products.filter((item) => {
          return !item.active
        })
      }
    }
  }
</script>
